<template>
  <v-container
    fluid
    :class="this.$vuetify.theme.dark ? '' : 'grey lighten-4'"
    style="min-height: 110vh"
  >
    <v-row align="center" justify="center" class="table-cell">
      <v-col cols="12" md="5" sm="12" class="ma-3">
        <v-form v-model="valid" ref="form">
          <v-card elevation="1" class="mx-auto pa-3">
            <v-card-title
              ><h1>
                Rest password<span style="color: #ff9800">
                  Quick delivery system</span
                >
                account
              </h1></v-card-title
            >
            <v-text-field
              ref="password"
              v-model="password"
              :rules="[rules.required, rules.min_password]"
              prepend-icon="mdi-eye"
              label="Password"
              placeholder="password"
              required
              outlined
            />
            <v-text-field
              ref="confirmPassword"
              v-model="confirmPassword"
              :rules="[rules.required, rules.confirmPasswordRules]"
              prepend-icon="mdi-eye"
              label="Confirm Password"
              placeholder="confirm Password"
              required
              outlined
            />
            <span class="mt-2" v-if="errorMessages" style="color: red"
              >{{ successMessages }}{{ errorMessages }}</span
            >

            <v-btn
              color="primary"
              block
              dark
              @click.prevent="restPassword"
              :disabled="clicked"
            >
              Set password
            </v-btn>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="table-cell">
      <footerTop class="ma-0 text--center" />
      <siteFooter class="ma-0" />
    </v-row>
  </v-container>
</template>
<script>
import _ from "lodash";
import siteFooter from "../components/siteFooter.vue";
import footerTop from "../components/footerTop.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { siteFooter, footerTop },
  name: "set-password",
  data() {
    return {
      password: "",
      confirmPassword: "",
      authKey: "",
      clicked: false,
      valid: true,
      rules: {
        required: null,
        min_password: null,
        confirmPasswordRules: null,
      },
    };
  },
  created() {
    this.rules.confirmPasswordRules = (value) =>
      value == this.password || this.$t("rules.confirmPassword");
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.min_password = (v) =>
      v.length >= 6 || this.$t("rules.min_password");
  },
  computed: {
    ...mapGetters("alert", ["errorMessages", "successMessages"]),
  },

  mounted() {

    if (_.isEmpty(this.$router.history.current.params.key)) {
      // error
      // this.error({
      //   showType: "toast",
      //   title: "Error",
      //   text: "This is not valid access. Please try again.",
      // });
      this.$router.push("/login");
    } else {
      // all good
      this.authKey = this.$router.history.current.params.key;
      //  this.handleAuthMessageKey({ messageKey: this.$route.query.messageKey });
    }
  },
  methods: {
    // ...mapActions("auth", ["handleAuthMessageKey"]),
    ...mapActions("alert", ["error"]),
  },
  methods: {
    restPassword() {
      this.$refs.form.validate();
      if (this.valid == false) return;

      this.clicked = true;

      const payload = {
        key: this.authKey,
        password: this.password,
      };
      this.$store.dispatch("users/setPassword", payload).then(() => {
        this.$router.push("/login");
      });
      this.clicked = false;
    },
  },
};
</script>
